import React from 'react';
import { Check } from 'lucide-react';
import { Reveal } from '../Reveal';
const puntos = ["+300 páginas de contenido estructurado.", "60+ clases completas listas para dar.", 'Fundamentos · Básico · Intermedio · Avanzado · Gestión · Marketing · Programa anual.', 'Planificación · Corrección · Seguridad · Fidelización · Comunicación.', 'Funciona desde hoy mismo en tu espacio.'];
const etiquetas = ['🟢 Principiante', '🟡 Intermedio', '🔴 Avanzado', '💼 Gestión', '📱 Marketing', '📅 Programa anual'];
export function Solucion() {
  return <section aria-labelledby="solucion-titulo" className="w-full bg-crema px-4 py-16 sm:px-6 sm:py-20" data-id="element-233" data-mp="2gduigq5zpfrb">
      <div className="mx-auto max-w-4xl text-center" data-id="element-234" data-mp="2l6xd71mi6v93">
        <Reveal data-id="element-235" data-mp="2q5qjoa3dhlzr">
          <span className="inline-block rounded-full bg-dorado/20 px-4 py-2 text-xs font-semibold uppercase tracking-wide text-bordo ring-1 ring-dorado/50" style={{
          fontSize: "11px"
        }} data-id="element-236" data-mp="2q46zw9iicst8">
            Sistema N°1 para Profes de Telas en Argentina
          </span>
        </Reveal>

        <Reveal delay={0.05} data-id="element-237" data-mp="21g27eauc0kyt">
          <h2 id="solucion-titulo" className="mt-6 font-display text-3xl font-bold text-tinta sm:text-5xl" data-id="element-238" data-mp="21gbzq52un47o">
            PROFES DE TELAS RESUELTO™
          </h2>
        </Reveal>

        <Reveal delay={0.07} data-id="element-239" data-mp="1se2plgbhtcut">
          <p className="mt-3 text-base font-bold uppercase tracking-[0.16em] text-bordo sm:text-lg" data-id="element-240" data-mp="1sfdz7wrmdetu">
            MEGAPACK — SISTEMA COMPLETO
          </p>
        </Reveal>

        <Reveal delay={0.09} data-id="element-241" data-mp="2l2hz5nbuv2yr">
          <p className="mt-4 text-base text-tintasuave sm:text-lg" data-id="element-242" data-mp="2l2qc1f7za89y">
            7 Tomos + 5 Bonos — Todos los niveles — Todo resuelto.
          </p>
        </Reveal>

        <Reveal delay={0.1} data-id="element-243" data-mp="2bcoocojjervk">
          <div className="mt-10 overflow-hidden rounded-2xl border border-black/5 bg-white text-left shadow-soft" data-id="element-244" data-mp="2bbvrcfadrgqm">
            <div className="h-1 w-full bg-gradient-to-r from-bordo via-dorado to-verde" aria-hidden="true" data-id="element-245" data-mp="26cj25nw1dxkv" />
            <ul className="space-y-4 p-6 sm:p-9" data-id="element-246" data-mp="33vu7n64rav77">
              {puntos.map(punto => <li key={punto} className="flex items-start gap-3" data-id="element-247" data-mp="2z1zt0h40d6ez">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-verde/15" data-id="element-248" data-mp="x6tn4gi7dbo0">
                    <Check className="h-4 w-4 text-verde" aria-hidden="true" data-id="element-249" data-mp="116ue10mhnfby" />
                  </span>
                  <span className="text-sm leading-relaxed text-tinta sm:text-base" style={{
                fontSize: "13px"
              }} data-id="element-250" data-mp="nffsam175017">{punto}</span>
                </li>)}
            </ul>
          </div>
        </Reveal>

        <Reveal delay={0.12} data-id="element-251" data-mp="dg86dagebx2h">
          <h3 className="mt-12 font-display text-xl font-bold text-bordo sm:text-2xl" data-id="element-252" data-mp="dk4bzza53krc">
            📚 Niveles y enfoques incluidos:
          </h3>
          <ul className="mt-6 flex flex-wrap justify-center gap-2.5" data-id="element-253" data-mp="4i4wxcioqqr1">
            {etiquetas.map(etiqueta => <li key={etiqueta} className="rounded-full border border-black/5 bg-white px-4 py-2 text-sm font-semibold text-tinta shadow-sm" data-id="element-254" data-mp="9h7qo0t7tajp">
                {etiqueta}
              </li>)}
          </ul>
        </Reveal>
      </div>
    </section>;
}